import loadable from '@loadable/component';
import { DOMAIN_PREFIX } from 'helpers/fieldOptions/domainPrefix';
import { FAVORITE_URL_KEY_BY_LOCALE } from 'helpers/namedUrls/getFavoritesUrl';

export default [
  {
    path: `/${DOMAIN_PREFIX}/`,
    exact: true,
    component: loadable(() => import('../../../pages/Search')),
  },
  {
    path: `/${DOMAIN_PREFIX}${FAVORITE_URL_KEY_BY_LOCALE}`,
    exact: true,
    component: loadable(() => import('../../../pages/FavoritesOverview')),
  },
  {
    path: `/${DOMAIN_PREFIX}/:pathTitle/mid/:midPage*`,
    exact: true,
    component: loadable(() => import('../../../pages/MIDPagesRedirect')),
  },
  {
    path: `/${DOMAIN_PREFIX}/:route*`,
    component: loadable(() => import('../../../pages/CmsSeoTemplate')),
  },
  {
    path: '/inspection/:carLeadHash/preview',
    component: loadable(() => import('../../../pages/InspectionV2Preview')),
  },
  {
    path: '*',
    component: loadable(() => import('../../../pages/NotFound')),
  },
];
